export default "__VITE_ASSET__C2y3SBD$__"